export interface AttestmentData {
  attestedAt?: Date;
  attestmentText: string;
  userId?: string;
}

export enum DomesticContentAttestmentType {
  pvOnly = 'pvOnly',
  storageOnly = 'storageOnly',
  pvAndStorage = 'pvAndStorage',
  optOut = 'optOut',
}

export interface DomesticContentAttestmentData {
  attestedAt: Date;
  userId: string;
  valueConfirmation: boolean;
  resubmission?: boolean;
  attestmentType?: DomesticContentAttestmentType;
  /** Per-request intent signal, required to opt out an account whose domestic content is already
   * confirmed. Never persisted: an inherited value would leave the guard permanently satisfied on
   * that account, so it is read from the incoming payload only and stripped before the design is
   * written. */
  acknowledgeConfirmedDowngrade?: boolean;
}

export enum InstallAttestmentType {
  generatorSizing = 'generatorSizing',
  coDetectors = 'coDetectors',
  noConflictingDownstreamGeneration = 'noConflictingDownstreamGeneration',
  loadControlDevices = 'loadControlDevices',
  permitting = 'permitting',
  documentationAccuracy = 'documentationAccuracy',
  customerWalkthrough = 'customerWalkthrough',
}

export enum PermitAttestmentSelection {
  permitObtained = 'permitObtained',
  noPermitRequired = 'noPermitRequired',
}

export interface InstallAttestmentItem {
  attestedAt?: Date;
  userId?: string;
  attestmentType: InstallAttestmentType;
  copyVersion: string;
  permitSelection?: PermitAttestmentSelection;
}

export interface InstallAttestmentInput {
  attestmentType: InstallAttestmentType;
  hasRead: boolean;
  permitSelection?: PermitAttestmentSelection;
}
